import {
  actualizarFactor,
  crearFactor,
  eliminarFactor,
  getFactores,
  getTipoAutoevaluaciones,
} from 'api/factor'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import swal from 'sweetalert2'

const key = 'factors'
export function useObtenerFactor(buscar) {
  return useQuery(key, () => getFactores(buscar))
}

export function useObtenerTipoAutoevaluacion(buscar) {
  return useQuery('tipo_autoevaluacion', () => getTipoAutoevaluaciones(buscar))
}

export function useCrearFactor() {
  const queryClient = useQueryClient()
  return useMutation(crearFactor, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarFactor() {
  const queryClient = useQueryClient()
  return useMutation(actualizarFactor, {
    onSuccess: (_, value) => {
      const { id, values: factorActualizada } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((factor) => {
          let nuevaFactor = factor
          if (id === factor.id) {
            nuevaFactor = factorActualizada
          }
          return nuevaFactor
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarFactor() {
  const queryClient = useQueryClient()
  return useMutation(eliminarFactor, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (factor) => factor.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useFactor(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarFactor } = useEliminarFactor()
  const { mutateAsync: actualizarFactor } = useActualizarFactor()
  const { mutateAsync: crearFactor } = useCrearFactor()

  const handleCrearFactor = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearFactor(values)
      const message = `El factor ${data.nombre} fue creado satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarFactor = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarFactor({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'El factor fue actualizado satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarFactor = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarFactor(id)
          const message = `El factor ${data} fue eliminado satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarFactor = async (value) => {
    queryClient.prefetchQuery(key, () => getFactores(value))
  }

  return {
    obtenerFactores: useObtenerFactor,
    obtenerTipoAutoevaluaciones: useObtenerTipoAutoevaluacion,
    handleEliminarFactor,
    handleActualizarFactor,
    handleCrearFactor,
    handleBuscarFactor,
  }
}
